export const roadmapItems = [
    {
        percentage: '5%',
        description: 'Official Launch of Hashrate Studios at the NEARCON 2022.',
        isCompleted: true
    },
    {
        percentage: '7%',
        description: 'Official Launch of Hashrate Studios Discord Community.',
        isCompleted: true
    },
    {
        percentage: '20%',
        description: 'Launch of our Founders Collection, featuring unique and limited Membership NFTs.',
        isCompleted: false
    },
   
    {
        percentage: '40%',
        description: 'Launch our first project showcase.',
        isCompleted: false
    },
    {
        percentage: '55%',
        description: 'Launch of the first funding round.',
        isCompleted: false
    },
    // {
    //     percentage: '70%',
    //     description: 'Release of the NFT collections for another 4 Hashreels Episodes.',
    //     isCompleted: false
    // },
    {
        percentage: '85%',
        description: 'Launch of the Writer\'s Workshop community feature.',
        isCompleted: false
    },
    {
        percentage: '100%',
        description: 'Announcement of first feature option and subsequent release of NFT collection.',
        isCompleted: false
    },
]
